"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sendAs = require("../../store/send-as/send-as.actions");

var _gift = require("../../store/gift/gift.selector");

var _sendAs2 = require("../../store/send-as/send-as.selector");

var _gift2 = require("../../store/gift/gift.actions");

var _user = require("../../../Shared/store/user/user.selectors");

var GiftMessageSendAsSelect = function GiftMessageSendAsSelect(_ref) {
  var onChange = _ref.onChange;
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentUserId = (0, _reactRedux.useSelector)(_user.getUserId);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var users = (0, _reactRedux.useSelector)(_sendAs2.getSendAsList);
  var isUsersLoading = (0, _reactRedux.useSelector)(_sendAs2.getSendAsIsLoading);
  var isSendAsLocked = (0, _reactRedux.useSelector)(_gift.getIsSendAsLocked);
  var sendAsUserId = (0, _reactRedux.useSelector)(_gift.getSendAsUserId);
  var campaignId = (0, _reactRedux.useSelector)(_gift.getGiftCampaignId);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var teamId = campaign === null || campaign === void 0 ? void 0 : campaign.team.id;
  (0, _react.useEffect)(function () {
    if (teamId && giftId) {
      dispatch((0, _sendAs.loadSendAsRequest)(teamId, giftId));
    }
  }, [dispatch, teamId, giftId]);
  var onSendAsChange = (0, _react.useCallback)(function (_ref2) {
    var target = _ref2.target;
    dispatch((0, _gift2.giftSetSendAsRequest)({
      giftId,
      userId: target.value
    }));
    onChange({
      giftId,
      userId: target.value
    });
  }, [dispatch, giftId, onChange]);
  return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "gift-message-select-send-as-label"
  }, "Send this message as"), /*#__PURE__*/_react.default.createElement(_material.Select, {
    label: "Send this message as",
    labelId: "gift-message-select-send-as-label",
    disabled: isUsersLoading || isSendAsLocked,
    value: sendAsUserId,
    onChange: onSendAsChange
  }, users.map(function (user) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      style: {
        color: !user.isAvailable ? '#B0B0B0' : '#029cef'
      },
      key: user.id,
      value: user.id,
      disabled: !user.isAvailable
    }, user.id === currentUserId ? "Myself (".concat(user.first_name, " ").concat(user.last_name, ")") : "".concat(user.first_name, " ").concat(user.last_name, " ").concat(!user.isAvailable ? ' — Insufficient budget' : ''));
  })), /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, isSendAsLocked && 'This send as has been locked by your team admin in the campaign settings.'));
};

GiftMessageSendAsSelect.propTypes = {
  onChange: _propTypes.default.func
};
GiftMessageSendAsSelect.defaultProps = {
  onChange: function onChange() {}
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftMessageSendAsSelect);

exports.default = _default;